import netWorkController from "@/http/netWorkController";
import cookieUtils from "@/utils/cookieUtils";
import toastUtils from "@/utils/toastUtils";
import dateUtils from "@/utils/dateUtils";
import logFileListDialog from "@/views/LogFileListDialog";
import {MessageType} from "@/utils/messageType";

export default {
    name: "MessageListPage",
    components: {logFileListDialog},
    //简单声明接收参数
    props: ['messageType', 'messageSeq'],
    created() {
        const userInfoStr = window.localStorage.getItem("userInfo")
        if (userInfoStr) {
            this.userInfo = JSON.parse(userInfoStr)
            netWorkController.appList(this.userInfo.id, this.userInfo.accessToken, (result) => {
                if (result.data) {
                    this.appList = result.data
                    let appIdCache = cookieUtils.get("appIdCache")
                    if (appIdCache) {
                        this.requestForm.appId = Number.parseInt(appIdCache);
                    } else {
                        this.requestForm.appId = this.appList[0].id
                    }
                    this.messagePageList()
                } else {
                    toastUtils.warning(this, result.msg)
                }
            })
        }
    },
    data() {
        return {
            dialogVisible: false,
            appList: [],
            messageTypes: [
                {name: "更新本地消息seq的消息", value: MessageType.S_SEQ_UPDATE},
                {name: "GPS上传", value: MessageType.S_GPS},
                {name: "本地日志上传", value: MessageType.S_UPLOAD_LOG},
                {name: "自定义消息", value: MessageType.S_CUSTOM},
                {name: "在线日志开关", value: MessageType.S_SWITCH_LOG},
                {name: "关键日志开关", value: MessageType.S_CRITICAL_LOG},
                {name: "全部消息", value: null}
            ],
            ackStateTypes: [
                {name: "无需确认", value: -1},
                {name: "未确认", value: 0},
                {name: "已确认", value: 1},
                {name: "全部", value: null}
            ],
            requestForm: {
                appId: -1,
                ///当前页数
                pageNum: 1,
                ///一页总数
                pageSize: 10,
                ///总条数
                total: 0,
                messageSeq: this.messageSeq,
                messageContent: null,
                messageType: this.messageType,
                ackState: null
            },
            list: [],
            fileList: [],
        }
    },
    methods: {
        formatDate(row, column, cellValue) {
            return dateUtils.timestampToDate(cellValue);
        },
        formatAck(row, column, cellValue) {
            if (cellValue === -1) {
                return "无需确认"
            }
            if (cellValue === 1) {
                return "已确认"
            }
            return "未确认";
        },
        formatMsgType(row, column, cellValue) {
            let msgType;
            switch (cellValue) {
                case MessageType.S_SEQ_UPDATE:
                    msgType = "更新Seq"
                    break
                case MessageType.S_GPS:
                    msgType = "GPS上传"
                    break
                case MessageType.S_UPLOAD_LOG:
                    msgType = "本地日志上传"
                    break
                case MessageType.S_CUSTOM:
                    msgType = "自定义消息"
                    break
                case MessageType.S_SWITCH_LOG:
                    msgType = "在线日志开关"
                    break
                case MessageType.S_CRITICAL_LOG:
                    msgType = "关键日志开关"
                    break
                default:
                    msgType = cellValue ?? "未知类型"
            }
            return msgType;
        },
        formatPushType(row, column, cellValue) {
            if (cellValue === 0) {
                return "广播"
            }
            return "单播";
        },
        handleSizeChange(value) {
            if (value) {
                this.requestForm.pageSize = value
                this.messagePageList()
            }
        },
        handleCurrentChange(value) {
            if (value) {
                this.requestForm.pageNum = value
                this.messagePageList()
            }
        },
        onchange(value) {
            cookieUtils.set("appIdCache", value);
            this.messagePageList()
        },
        messagePageList() {
            netWorkController.messagePageList(this.requestForm, (result) => {
                if (result.status === 200) {
                    this.list = result.data.list;
                    this.requestForm.pageNum = result.data.pageNum;
                    this.requestForm.total = result.data.total
                } else {
                    toastUtils.warning(result.msg)
                }
            })
        },
        rePush(data) {
            if (data) {
                netWorkController.pushMessage(data, (result) => {
                    if (result.status === 200) {
                        toastUtils.success(this, result.msg)
                        setTimeout(() => {
                            window.doOpen(this, "/messageListPage", {messageSeq: result.data})
                            if (this.requestForm.pageNum === 1) {
                                this.messagePageList()
                            }
                        }, 500);
                    } else {
                        toastUtils.warning(this, result.msg)
                    }
                })
            }
        },
        showLogFileDialog(value) {
            if (value) {
                netWorkController.fileListForSeq(value, (result) => {
                    if (result.status === 200) {
                        this.fileList = result.data;
                        this.dialogVisible = true
                    } else {
                        toastUtils.warning(result.msg)
                    }
                });
            }
        },
        dialogClick() {
            this.dialogVisible = false
        }
    }


}